import { render } from "./TrabajadorList.vue?vue&type=template&id=3fb2b44a&scoped=true"
import script from "./TrabajadorList.vue?vue&type=script&lang=js"
export * from "./TrabajadorList.vue?vue&type=script&lang=js"

import "./TrabajadorList.vue?vue&type=style&index=0&id=3fb2b44a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb2b44a"]])

export default __exports__